import PropTypes from 'prop-types';
import { HiMagnifyingGlass } from 'react-icons/hi2';

import TextInput from '#globalComponents/Forms/TextInput';

import ViewModeToggle from './ViewModeToggle';

const CollectionToolbar = ({ search, onSearchChange, searchPlaceholder, viewMode, onViewModeChange, children }) => (
	<div className="mb-5 flex items-center gap-4">
		<div className="relative w-full max-w-sm">
			<HiMagnifyingGlass className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-bgBase-700" />
			<TextInput
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				placeholder={searchPlaceholder}
				aria-label={searchPlaceholder}
				className="pl-10"
			/>
		</div>
		<ViewModeToggle value={viewMode} onChange={onViewModeChange} />
		{children && <div className="ml-auto flex items-center gap-2">{children}</div>}
	</div>
);

CollectionToolbar.propTypes = {
	search: PropTypes.string.isRequired,
	onSearchChange: PropTypes.func.isRequired,
	searchPlaceholder: PropTypes.string.isRequired,
	viewMode: PropTypes.oneOf(['grid', 'list']).isRequired,
	onViewModeChange: PropTypes.func.isRequired,
	children: PropTypes.node,
};

export default CollectionToolbar;
